export { ReactComponent as CasinoIcon } from './casino.svg';
export { ReactComponent as LiveCasinoIcon } from './live_casino.svg';
export { ReactComponent as AppleIcon } from './apple.svg';
export { ReactComponent as AndroidIcon } from './android.svg';
export { ReactComponent as WhiteLogoIcon } from './white_logo.svg';
export { ReactComponent as JuneLogo } from './june_logo.svg';
export { ReactComponent as ArrowIcon } from './arrow.svg';
